export default __webpack_public_path__ + "static/media/741.f1dc47dd.png";